jQuery(function ( $ ) {
	'use strict';

	console.log( $( 'body' ).hasClass( 'page-template-template-taste-mixer' ) );

	if ( ! $( 'body' ).hasClass( 'page-template-template-taste-mixer' ) ) {
		return;
	}

	$( '#mixer-input' ).chosen( {
		width: '100%',
		max_shown_results: 8
	} );

	$.fn.mixer_update_section = function( ingredients, time, portions, difficulty, emotions ) {

		var ingredients = ingredients || '';
		var time = time || '';
		var portions = portions || '';
		var difficulty = difficulty || '';
		var emotions = emotions || '';

		if ( ingredients == '' ) {
			ingredients = $( '#mixer-input' ).val();
		}

		if ( time == '' ) {
			time = $( '#mixer-input-wrapper #time-select' ).val();
		}

		if ( portions == '' ) {
			portions = $( '#mixer-input-wrapper #portions-select' ).val();
		}

		if ( difficulty == '' ) {
			difficulty = $( '#mixer-input-wrapper #difficulty-select' ).val();
		}

		if ( emotions == '' ) {
			emotions = $( '#mixer-input-wrapper #emotions-select' ).val();
		}

		var $elem = $(this);

		$elem.addClass( 'loading' );

		$.get( wps.ajax, {
			action:      'mixer_get_recipes',
			ingredients: ingredients,
			time:        time,
			portions:    portions,
			difficulty:  difficulty,
			category:    emotions
		}, function( response ) {

			if ( ! response.success ) {

				alert( response.data );

			} else {

				$elem.html( response.data.html );

				if ( response.data.related && 1 > $elem.siblings( '.related-posts' ).length ) {
					$elem.after( response.data.related );
				} else if ( 1 <= $elem.siblings( '.related-posts' ).length ) {
					$elem.siblings( '.related-posts' ).remove();
				}

			}

			$elem.removeClass( 'loading' );

		} );

		return this;

	}

	var mixer_already_exists = function( ingredients ) {

		var exists = false;

		$( '#mixer-search-results .' + ingredients.join( '.' ) ).each( function() {

			if ( $(this).data( 'ingredients' ) == ingredients.join( '-' ) ) {
				exists = true;
			}

		} );

		return exists;

	}

	var mixer_remove_ingredient = function( ingredient ) {

		$( '#mixer-search-results .' + ingredient ).each( function( index, elem ) {

			if ( ! $( elem ).hasClass( ingredient ) ) {
				return false;
			}

			$( elem ).removeClass( ingredient );

			var elem_classes = $( elem ).attr( 'class' );

			if ( elem_classes.length == 0 ) {

				$( elem ).remove();

			} else {

				var new_ingredients = elem_classes.split( /\s+/ );

				if ( mixer_already_exists( new_ingredients ) ) {
					$( elem ).remove();
				} else {
					$( elem ).mixer_update_section( new_ingredients );
				}

			}

		} );

	}

	$( '#mixer-input' ).on( 'change', function( event, data ) {

		var $input = $(this);

		if ( data.selected ) {

			var ingr_raw  = $input.val();
			var css_class = ingr_raw.join( ' ' );
			var data_ingr = ingr_raw.join( '-' );

			var $new_section = $( '<div/>', {
				class:                  css_class,
				'data-ingredients':     data_ingr,
				'data-ingredients-raw': JSON.stringify( ingr_raw )
			} );

			$new_section.appendTo( '#mixer-search-results' );
			$new_section.mixer_update_section( $input.val() );

		} else if ( data.deselected ) {

			mixer_remove_ingredient( data.deselected );

		}

	} );

	$( '#time-select, #portions-select, #difficulty-select, #emotions-select' ).on( 'change', function() {

		$( '#mixer-search-results > div' ).each( function() {

			var $section = $(this);
			$section.mixer_update_section( $section.data( 'ingredients-raw' ) );

		} );

	} );

	var $container = $( '.chosen-container' ),
		$search_field = $container.find( 'input[type="text"]' );

	$search_field.on( 'keydown', function ( e ) {
		if ( ',' !== e.key ) {
			return true;
		}

		e.preventDefault();

		if ( 1 !== $container.find( '.chosen-results .highlighted' ).length ) {
			return;
		}

		var index = parseInt( $container.find( '.chosen-results .highlighted' ).data( 'option-array-index' ), 10 );
		var $input = $( '#mixer-input' );
		$input.find( 'option:eq(' + index + ')' ).appendTo( $input ).prop( 'selected', true ).end().trigger( 'chosen:updated' );
	});

	$( '.mikser-search-bar [type="submit"], .search-submit-button-mobile' ).on( 'click', function ( e ) {
		e.preventDefault();

		$( 'html,body' ).animate({
			scrollTop: $( '#mixer-search-results' ).offset().top - $( '.site-header' ).height() - 20
		}, 250 );
	});

	/* Fix for mobile browsers since jQuery Chosen does not support those. */
	$('.chosen-choices').on('touchend', '.search-choice-close', function(){
		var $this = $(this);
		var $select = $this.closest('.chosen-container').prev('select');
		var toRemove = $.trim($this.parent().text());
		var vals = $select.val();
		vals = $.grep(vals, function(value) {
			return $.trim(value).trim() !== toRemove;
		});
		$select.val(vals).trigger('chosen:updated');
   });

});
